import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleRouting } from './digi.routing';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../shared/material/material.module';
import { DigiConnectComponent } from './digi-connect/digi-connect.component';
import { SocketService } from '../shared/services/socket.service';
import { SharedModule } from '../shared/shared.module';
import { DigiGameComponent } from './digi-game/digi-game.component';
import { DigiResultComponent } from './digi-result/digi-result.component';
import { AutofocusDirective } from '../shared/autofocus.directive';
import { ApiService } from '../shared/services/api.service';
import { StorageService } from '../shared/services/storage.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';



import { CanActivateDigiGame } from './digi-game/can-activate.guard';
import { DialogGameResultComponent } from './digi-game/dialog-game-result/dialog-game-result.component';

@NgModule({
  imports: [
    CommonModule,
    ModuleRouting,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    BrowserAnimationsModule
  ],
  exports: [DialogGameResultComponent],
  declarations: [DigiConnectComponent, DigiGameComponent, DigiResultComponent, AutofocusDirective, DialogGameResultComponent],
  providers: [SocketService, ApiService, StorageService, CanActivateDigiGame],
  entryComponents: [DialogGameResultComponent]
})
export class DigiModule { }



// WEBPACK FOOTER //
// ./src/app/digi/digi.module.ts